export default {"src":"/_next/static/media/crpt.f5cc6486.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};